import { useEffect, useRef, useState, useCallback } from "react";
import styles from "../../../pages/ordermanager/Orders.module.css";
import { CloseIcon } from "../../icons/Icon2";
import Button from "../Dealers/Button";

const DeliveryInstructionsModal = ({
  mode,
  handleCloseModal,
  warehouses,
  handleSubmit,
  handleInstructionChange,
}) => {
  const textAreaRef = useRef([]);
  const lastKeyPressRef = useRef({});
  const [instructions, setInstructions] = useState({});

  useEffect(() => {
    textAreaRef.current[0]?.focus();
  }, []);

  const handleChange = useCallback(
    (warehouseId, value, index) => {
      const cleanedValue = value.replace(/[\n\r]+$/, "");

      setInstructions((prev) => ({ ...prev, [index]: cleanedValue }));

      handleInstructionChange(warehouseId, cleanedValue);
    },
    [handleInstructionChange]
  );

  const handleKeyDown = (e, i) => {
    if (e.key === "Enter") {
      if (lastKeyPressRef.current[i] === "Enter") {
        e.preventDefault();

        if (i < warehouses.length - 1) {
          textAreaRef.current[i + 1]?.focus();
        } else {
          setTimeout(() => {
            handleSubmit();
          }, 0);
        }

        lastKeyPressRef.current[i] = null;
      } else {
        e.preventDefault();
        setInstructions((prev) => ({
          ...prev,
          [i]: (prev[i] || "") + "\n",
        }));

        lastKeyPressRef.current[i] = "Enter";
      }
    } else {
      lastKeyPressRef.current[i] = null;
    }
  };

  const submitData = () => {
    handleSubmit();
  };

  return (
    <div
      className={styles.delivery_instructions_modal}
      style={{ backgroundColor: mode ? "#232529" : "#fff" }}
    >
      <div className={styles.modal_header}>
        <p style={{ color: mode ? "#FFFFFF" : "#000" }}>
          Delivery Instructions
        </p>
        <div onClick={handleCloseModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <div className={styles.text_area_sec}>
        <p style={mode ? { color: "#FFFFFF" } : {}}>
          Enter delivery instructions for this order.
        </p>

        {warehouses.map((w, i) => (
          <textarea
            key={i}
            placeholder={`Enter instructions for ${w.warehouse} items`}
            rows="4"
            value={instructions[i] || ""}
            onChange={(e) => handleChange(w.warehouseId, e.target.value, i)}
            autoComplete="off"
            spellCheck="false"
            autoCorrect="off"
            autoCapitalize="off"
            className={`${styles.textarea} ${mode ? styles.textarea_dark : ""}`}
            ref={(el) => (textAreaRef.current[i] = el)}
            onKeyDown={(e) => handleKeyDown(e, i)}
            maxLength={500}
          />
        ))}
      </div>

      <div className={styles.bottom_buttons} style={{ width: "100%" }}>
        <div style={{ width: "50%" }}>
          <Button
            buttonText={"Close"}
            buttonBgColor={"#000000"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonClick={handleCloseModal}
          />
          <p
            className={styles.btn_text}
            style={mode ? { color: "#FFFFFF" } : {}}
          >
            Press - C
          </p>
        </div>
        <div style={{ width: "50%" }}>
          <Button
            buttonText={"Save & Place Order"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonClick={submitData}
          />
          <p
            className={styles.btn_text}
            style={mode ? { color: "#FFFFFF" } : {}}
          >
            Press - S
          </p>
        </div>
      </div>
    </div>
  );
};

export default DeliveryInstructionsModal;
